import apiClient from '../apiClient';
import { DELETE_TRANSPORTATION_UNIT_URL } from '../apiUrl';

const deleteTrasportationUnitApi = Id => {
  return apiClient.delete(DELETE_TRANSPORTATION_UNIT_URL(Id));
};

export default deleteTrasportationUnitApi;
